import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-shared-profile',
  templateUrl: './shared-profile.component.html',
  styleUrls: ['./shared-profile.component.css']
})
export class SharedProfileComponent implements OnInit {
  @Input() props: any;
  @Input() type: string
  @Input() loading: string

  url
  text = "Loading..."
  secondText = "Loading..."
  urlSecond
  arr = [1, 2, 3, 4, 5]
  id: any;

  slideConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 1,
    "infinite": true,
    "autoplay": false,
    "dots": true,
    "arrows": true,
    "centerMode": false,
    "variableWidth": false,
    "swipeToSlide": true,
    "touchMove": true,
    "useCSS": true,
    "useTransform": true,
    "fade": false,
    "speed": 300,
    "responsive": [
      {
        "breakpoint": 1200,
        "settings": {
          "slidesToShow": 3,
          "slidesToScroll": 1
        }
      },
      {
        "breakpoint": 768,
        "settings": {
          "slidesToShow": 2,
          "slidesToScroll": 1
        }
      },
      {
        "breakpoint": 480,
        "settings": {
          "slidesToShow": 1,
          "slidesToScroll": 1
        }
      }
    ]
  };
  currentUser: any;
  communityData: any;
  baseUrl = environment.imgUrl;
  
  // Our Staff section state
  staffItems: any[] = [];
  staffTypesMap: { [id: string]: string } = {};
  staffSkip = 0;
  staffLimit = 10;
  staffTotal = 0;
  loadingStaff = false;
  staffSlideConfig = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    autoplay: false,
    dots: true,
    arrows: true,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  constructor(
    private router: Router,
    private authService: AuthservicesService,
    private rt: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.id = this.rt.snapshot.params['id'];
    if (this.id) {
      this.communityDetail(this.id);
    }
    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
    setTimeout(() => {
      if (!this.props?.isFollowed) {
        this.url = 'followCommunity'
        this.text = 'Follow'
      }
      else if (this.props?.isFollowed) {
        this.url = 'unfollowCommunity'
        this.text = 'Unfollow'
      }
      // if (!this.props.isPartner) {
      //   console.log('add partner', this.props.isPartner);
      //   this.urlSecond = "addPartner",
      //     this.secondText = 'Become Partner'
      // }
      // else if (this.props.isPartner) {
      //   console.log('remove partner', this.props.isPartner);
      //   this.urlSecond = "removePartner",
      //     this.secondText = 'Leave Partner'
      // }

    }, 1500)
    // Load staff types and list for the Our Staff section
    this.loadStaffTypes();
    this.loadStaffList();
  }


  breakpoint(e) {
    console.log('breakpoint');
  }

  afterChange(e) {
    console.log('afterChange');
  }

  beforeChange(e) {
    console.log('beforeChange');
  }

  // ===== Our Staff helpers =====
  loadStaffTypes() {
    this.authService.getStaffType().subscribe(
      (res: any) => {
        const items = Array.isArray(res?.items) ? res.items : [];
        this.staffTypesMap = items.reduce((acc: any, cur: any) => {
          acc[cur?._id] = cur?.name;
          return acc;
        }, {});
      },
      error => {
        console.log(error)
      }
    )
  }

  loadStaffList() {
    this.loadingStaff = true;
    this.authService.staffList(this.staffSkip, this.staffLimit).subscribe(
      (res: any) => {
        const items = Array.isArray(res?.items) ? res.items : [];
        // Extract all staffId from all items and flatten into a single array
        this.staffItems = [];
        items.forEach((it: any) => {
          const staffIdArray = Array.isArray(it?.staffId) ? it.staffId : [];
          const staffTypeId = it?.staffType?._id || it?.staffType;
          const staffTypeName = this.staffTypesMap[staffTypeId] || it?.staffType?.name;
          
          // Map each staff member in the staffId array
          staffIdArray.forEach((staff: any) => {
            this.staffItems.push({
              id: staff?._id || staff?.id,
              name: staff?.name,
              email: staff?.email,
              photo: staff?.photo,
              coverPhoto: staff?.coverPhoto,
              logLine: staff?.logLine,
              followersCount: staff?.followersCount,
              followingCount: staff?.followingCount,
              visitorsCount: staff?.visitorsCount,
              staffTypeName: staffTypeName,
            });
          });
        });
        console.log("iteeeeeeeeeeeeeeeeeeeeeee", items)
        console.log("thisstaffffffffffffItemsssssss", this.staffItems)

        // Update total to reflect all staff members, not just items
        this.staffTotal = this.staffItems.length;
        this.loadingStaff = false;
      },
      error => {
        console.log(error)
        this.loadingStaff = false;
      }
    )
  }

  nextStaffPage() {
    const nextSkip = this.staffSkip + this.staffLimit;
    if (nextSkip < this.staffTotal) {
      this.staffSkip = nextSkip;
      this.loadStaffList();
    }
  }

  prevStaffPage() {
    const prevSkip = this.staffSkip - this.staffLimit;
    if (prevSkip >= 0) {
      this.staffSkip = prevSkip;
      this.loadStaffList();
    }
  }

  follow() {
    this.authService.followUnfollow(this.url, this.props._id).subscribe((res: any) => {
      if (this.url == 'followCommunity') {
        this.url = 'unfollowCommunity'

        this.props.isFollowed = true
        this.text = 'Unfollow'

      } else if (this.url == 'unfollowCommunity') {
        this.props.isFollowed = false
        this.url = 'followCommunity'

        this.text = 'Follow'
      }
    },
      error => {
        console.log(error)
      })
  }

  messageAlert(message, type) {
    this.authService.successMessage(message, type)
  }

  managePartner(key:any){
    console.log('--key',key);
    if(key == 'Approved'){
      this.removePartner()
    } else if((key == 'Rejected') || (key == 'Become Partner')){
      this.addPartner()
    }
  }

  addPartner() {
    this.authService.addPartner(this.props._id).subscribe((res: any) => {
      console.log('ADD PARTNER --->',res)
      if(res.code == 200){
        this.messageAlert('Success', 'success')
        this.communityDetail(this.id)
      }
    },
      error => {
        console.log(error)
      })
  }

  removePartner() {

    this.authService.removePartner(this.props._id).subscribe((res: any) => {
      console.log('REMOVE PARTNER --->',res)
      if(res.code == 200){
        this.messageAlert('Success', 'success')
        this.communityDetail(this.id)
      }
      // if (this.urlSecond == 'addPartner') {
      //   this.urlSecond = 'removePartner'
      //   this.props.isPartner = true
      //   this.secondText = 'Leave Partner'
      // } else if (this.urlSecond == 'removePartner') {
      //   this.props.isPartner = false
      //   this.urlSecond = 'addPartner'
      //   this.secondText = 'Become Partner'
      // }
    },
      error => {
        console.log(error)
      })
  }

  communityDetail(id: any) {

    this.authService.communitydetails(id).subscribe((res: any) => {
      console.log("res?>>>>>>>>", res);
      if (res?.code == 200) {
        this.communityData = res?.data;
        this.props = res?.data;
        if (!res?.data.isFollowed) {
          this.url = 'followCommunity'
          this.text = 'Follow'
        }
        else if (res?.data.isFollowed) {
          this.url = 'unfollowCommunity'
          this.text = 'Unfollow'
        }

          if (res?.data.isPartner == 'Approved'){
            console.log('zzzzzzzzz',res?.data.isPartner);

            this.secondText = 'Leave Partner'
          }else if(res?.data.isPartner == 'Rejected'){
            console.log('zzzzzzzzz',res?.data.isPartner);
            this.secondText = 'Become Partner'
          } else if(res?.data.isPartner == 'Pending'){
            console.log('zzzzzzzzz',res?.data.isPartner);
            this.secondText = 'Pending'
          } else{
            // console.log('zzzzzzzzz',this.props.isPartner);
            this.secondText = 'Become Partner'
          }



      } else {
        this.communityData = [];
        this.props = [];
      }
      // console.log('props-----------128',this.props)
      // let arr = res?.data?.partners?.filter((data: any) => {
      //   return data?.id === this.props?._id;
      // });
    },
      error => {
        console.log(error)
      })
    // this.authService.communitydetails(this.currentUser.id).subscribe((res: any) => {
    //   this.communityData = res?.data;
    //   console.log('props-----------128', this.props)
    //   let arr = res?.data?.partners?.filter((data: any) => {
    //     return data?.id === this.props?._id;
    //   });
    //   console.log('filter', arr);
    // },
    //   error => {
    //     console.log(error)
    //   })
  }

  navigate() {
    return this.router.navigate(['/fellowship-directory/our-network', this.props._id])

  }

  getErrorImage(event) {
    this.authService.geterrorImage(event);

  }

  // renderImage(image:any) {
  //   if (image) {
  //     let imgarray = image?.split('/');
  //     if ((imgarray[0] == 'http:') && (imgarray[2] == 'localhost:9000')) {
  //       const [baseUrl, imgUrl] = image?.split('uploads');
  //       return `http://localhost:9000/uploads${imgUrl}`
  //       // return image;
  //     } else if((imgarray[0] == 'http:') && (imgarray[2] == 'stage-api.ravel.faith')){
  //       console.log('3333333333');
  //       return image
  //     }  else if(imgarray.length == 2){
  //       const [baseUrl, imgUrl] = image.split('uploads');
  //       return `${this.baseUrl}uploads${imgUrl}`
  //     }
  //   } else {
  //     return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
  //   }
  //   // if (image == undefined || image == null) {
  //   //   return
  //   // }
  //   // let result = this.authService.spilturl(image)
  //   // return result
  // }

  renderImage(photo: string) {
    if (photo != null) {
      const [baseUrl, imgUrl] = photo.split('uploads');
      // return `https://services.ravel.faith/uploads${imgUrl}`;
      return `http://localhost:9000/uploads${imgUrl}`
    }
    return 'assets/images/church.jpeg';
  }

  editProfile() {
    localStorage.removeItem('profileData');
    localStorage.setItem('profileData', JSON.stringify(this.props));
    this.router.navigate(['profile-management/edit-profile']);
  }
}
